import {gql} from 'apollo-boost';

export const GET_COURSE_FAQ = gql`
  query getCourseFAQ($id: ID!){
    getCourseFAQ(id: $id) {
      id unitSeq
      periodCode question answer
      hitRateCount hitRateDate postDate
      courseOutline { id }
      courseOutlineUnit { id }
      courseOutlineRegistration { id }
      classSection { id }
      academicPeriod { id }
      postByTeacher { id }
      postByUser { id }
      updatedAt
    }
  }
`;

export const GET_COURSE_FAQS = gql`
  query getCourseFAQs($id : ID!){
    getCourseFAQs (
      id: $id
    ) {
      id unitSeq
      periodCode question answer
      hitRateCount hitRateDate postDate
      courseOutline { id }
      courseOutlineUnit { id }
      courseOutlineRegistration { id }
      classSection { id }
      academicPeriod { id }
      postByTeacher { id }
      postByUser { id }
      updatedAt
    }
  }
`;

export const GET_COURSE_FAQS_BY_FILTER = gql`
  query getCourseFAQsByFilter($courseFAQFilterInput: CourseFAQFilterInput){
    getCourseFAQsByFilter (
      courseFAQFilterInput: $courseFAQFilterInput
    ) {
      id unitSeq
      periodCode question answer
      hitRateCount hitRateDate postDate
      courseOutline { id }
      courseOutlineUnit { id }
      courseOutlineRegistration { id }
      classSection { id }
      academicPeriod { id }
      postByTeacher { id }
      postByUser { id }
      updatedAt
    }
  }
`;

export const GET_COURSE_FAQS_BY_FILTER_CURRENT_TEACHER = gql`
  query getCourseFAQsByFilterCurrentTeacher($courseFAQFilterInput: CourseFAQFilterInput){
    getCourseFAQsByFilterCurrentTeacher (
      courseFAQFilterInput: $courseFAQFilterInput
    ) {
      id unitSeq
      periodCode question answer
      hitRateCount hitRateDate postDate
      courseOutline { id }
      courseOutlineUnit { id }
      courseOutlineRegistration { id }
      classSection { id }
      academicPeriod { id }
      postByTeacher { id }
      postByUser { id }
      updatedAt
    }
  }
`;

export const ADD_COURSE_FAQ = gql`
  mutation addCourseFAQ(
    $courseOutlineUnitId: ID!,
    $classSectionId: ID!,
    $courseFAQInput: CourseFAQInput!
  ) {
    addCourseFAQ(
      courseOutlineUnitId: $courseOutlineUnitId
      classSectionId: $classSectionId
      courseFAQInput: $courseFAQInput
    ) {
      id unitSeq
      periodCode question answer
      hitRateCount hitRateDate postDate
      courseOutline { id }
      courseOutlineUnit { id }
      courseOutlineRegistration { id }
      classSection { id }
      academicPeriod { id }
      postByTeacher { id }
      postByUser { id }
      updatedAt
    }
  }
`;

export const UPDATE_COURSE_FAQ = gql`
  mutation updateCourseFAQ(
    $id: ID!,
    $courseOutlineUnitId: ID!,
    $courseFAQInput: CourseFAQInput!
  ) {
    updateCourseFAQ(
      id: $id
      courseOutlineUnitId: $courseOutlineUnitId
      courseFAQInput: $courseFAQInput
    ) {
      id unitSeq
      periodCode question answer
      hitRateCount hitRateDate postDate
      courseOutline { id }
      courseOutlineUnit { id }
      courseOutlineRegistration { id }
      classSection { id }
      academicPeriod { id }
      postByTeacher { id }
      postByUser { id }
      updatedAt
    }
  }
`;

export const UPDATE_COURSE_FAQ_HIT_COUNT = gql`
  mutation updateCourseFAQHitCount(
    $id: ID!,
  ) {
    updateCourseFAQHitCount(
      id: $id
    ) {
      id unitSeq
      periodCode question answer
      hitRateCount hitRateDate postDate
      courseOutline { id }
      courseOutlineUnit { id }
      courseOutlineRegistration { id }
      classSection { id }
      academicPeriod { id }
      postByTeacher { id }
      postByUser { id }
      updatedAt
    }
  }
`;

export const DELETE_COURSE_FAQ = gql`
  mutation deleteCourseFAQ($id: ID!) {
    deleteCourseFAQ(
      id: $id
    ) {
      id unitSeq
      periodCode question answer
      hitRateCount hitRateDate postDate
      courseOutline { id }
      courseOutlineUnit { id }
      courseOutlineRegistration { id }
      classSection { id }
      academicPeriod { id }
      postByTeacher { id }
      postByUser { id }
      updatedAt
    }
  }
`;

